// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1y3Z9","col":"styles_col__1A1G0","fulfillmentStatus":"styles_fulfillmentStatus__3v3Sq","emailCol":"styles_emailCol__PfFEP"};